/** Shared el-table column widths for vật tư tables. */
export const VAT_TU_TABLE_COLUMN_WIDTHS = {
  stt: 70,
  ten: 200,
  ma: 100,
  dvt: 80,
  danhMuc: 180,
  soLuong: 120,
  soLuongCan: 120,
  soLuongNhap: 120,
  ghiChu: 150,
  thuHoi: 70,
  congTyQuanLy: 80,
  donGia: 120,
  thanhTien: 150,
  ketQuaKiemNghiem: 60,
  phuongThucKiemNghiem: 180,
  actions: 50,
} as const;

export const REPORT_COLUMN_WIDTHS = {
  stt: 30,
  soBienBanGiaiThe: 110,
  soPhieuXuat: 60,
  ngay: 70,
  ma: 60,
  ten: 100,
  dvt: 40,
  donGia: 80,
  soLuong: 80,
  thanhTien: 80,
  dacTinh: 90,
  dinhMucBbgt: 100,
  quantityGroup: 80 + 80,
  thanhTienGroup: 80 + 80,
} as const;

export const REPORT_COLUMN_WIDTHS_GROUP = {
  quantityThanhTienGroup:
    REPORT_COLUMN_WIDTHS.soLuong + REPORT_COLUMN_WIDTHS.thanhTien,
  thanhTienGroup:
    REPORT_COLUMN_WIDTHS.thanhTien + REPORT_COLUMN_WIDTHS.thanhTien,
  quantityDonGiaThanhTienGroup:
    REPORT_COLUMN_WIDTHS.soLuong +
    REPORT_COLUMN_WIDTHS.donGia +
    REPORT_COLUMN_WIDTHS.thanhTien,
} as const;
